import React, { useEffect, useRef, useState } from "react";

import styled from "styled-components/macro";

import API from "Signups/API.js";
import { signupItemStateHooks } from "Signups/SignupView/SignupSheet/Screens/SignupItems/stateHooks";
import { useGetSignupListType } from "Signups/SignupView/utils/useGetSignupListType";
import { useSignups } from "Signups/state.js";

import FnrButton from "UI/FnrButton3";

import {
  getNumberOfItemSlotsRemaining,
  getNumberOfPersonSlotsRemaining,
} from "./checkForAvailableSlots";

export default function AddAdditionalNamePopover({
  signupItemID,
  closePopover,
  userID,
  householdID,
  show,
}) {
  const [state, dispatch] = useSignups();
  const { isPollType } = useGetSignupListType();
  const inputRef = useRef();
  const [inputVal, setInputVal] = useState("");
  const [status, setStatus] = useState(null);
  const { getSignupItem, signupItem } = signupItemStateHooks.useGetSignupItem();

  const isItemSlotAvailable = getNumberOfItemSlotsRemaining(signupItem) > 0;
  const isPersonSlotAvailable =
    getNumberOfPersonSlotsRemaining(userID, householdID, signupItem) > 0;

  const itemIsFull =
    !isPollType && (!isItemSlotAvailable || !isPersonSlotAvailable);

  useEffect(() => {
    if (show) inputRef.current?.focus();
  }, [show]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (inputVal.trim() === "") return;
    setStatus("loading");

    API.addAdditionalName({
      name: inputVal,
      primaryUserID: userID, // ID of the user this name should be added under
      signupItemID,
      signupListID: state.currentSignupList.ID,
      signedUpViaID: 5,
    })
      .post()
      .then((responseData) => {
        getSignupItem(signupItemID);
        dispatch({
          type: "Other User Signup Updated",
          signupList: responseData.signupList,
          allSignupLists: responseData.allSignupLists,
        });
        setStatus(null);
        closePopover();
      })
      .catch((err) => {
        setStatus(null);
        alert(
          "There was a problem adding the user to the signup. Please try again later."
        );
        closePopover();
      });
  };

  if (itemIsFull) {
    return (
      <Wrapper>
        <ItemFull>
          This item is currently full. To add a member, please increase the
          number of available slots.
        </ItemFull>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <form onSubmit={handleSubmit}>
        <Label>Who is coming?</Label>
        <InputWrapper>
          <Input
            ref={inputRef}
            value={inputVal}
            onChange={(e) => setInputVal(e.target.value)}
            placeholder="Name"
          />
          <ButtonWrapper>
            <FnrButton size="small" color="blue" loading={status === "loading"}>
              Add
            </FnrButton>
          </ButtonWrapper>
        </InputWrapper>
      </form>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 240px;
  padding: 0 6px 6px 6px;
`;

const Label = styled.label`
  display: block;
  margin: 5px 0 3px;
`;

const InputWrapper = styled.div`
  padding: 2px 3px;
  background-color: white;
  border-radius: 10px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Input = styled.input`
  box-sizing: border-box;
  flex: 1;
  min-width: 20px;
  border: none;
  font-size: 17px;
  margin-left: 3px;
  height: 34px;
  outline: none;
`;

const ButtonWrapper = styled.div`
  flex-shrink: 0;
`;

const ItemFull = styled.div`
  padding: 5px;
  font-size: 15px;
`;
